module.exports = __webpack_public_path__ + "static/media/ic_template_14.ec8c00f9.png";